import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export function StackedBarVerticalChart({
  chartData,
  title,
  showTitle = true,
}: {
  chartData: any;
  title: string;
  showTitle?: boolean;
}) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: showTitle,
        text: `${title}`,
      },
    },
    indexAxis: 'x',
    scales: {
      x: {
        stacked: true,
        ticks: {
          precision: 0,
        },
      },
      y: {
        stacked: true,
      },
    },
    maintainAspectRatio: false,
  };

  // @ts-ignore
  return <Bar options={options} data={chartData} />;
}
